
 import adminUrls from "@/urls/events";
import {
  sendGetRequest, sendPostRequest,
} from "@/helper/requests";


const state = {
  records: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: {},
    error: null,
  }
};

const getters = {
  getRecords: state => state.records.items,
  getRecordsCount: state => state.records.count,
  getCurrentUrl: state => state.records.currentUrl,
  getRecordsDetail: state => state.records.detail,
  isLoadingRecords: state => state.records.loading,
  saveRecordsError: state => state.records.error,
};

const actions = {
  loadRecordsDetail: ({commit}, {url, token,finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.RECORDS.DETAIL(token)
    sendGetRequest(
        url, (data, url) => {
          commit('SET_RECORDS_DETAIL', data);
          finalizer(data, url);
        }, (data, url) => {
          commit('SAVE_RECORDS_ERROR', data);
          catcher(data, url);
        }
    )
  },
  loadRecordsTransfer: ({commit}, {url, data, event, id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.RECORDS.TRANSFER(event,id)
    sendPostRequest(
        url,data, (data, url) => {
          finalizer(data, url);
        }, (data, url) => {
          catcher(data, url);
        }
    )
  },
  loadRecordsList: ({commit, getters}, {url,event, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) {
      url = adminUrls.ADMIN.RECORDS.LIST(event)
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingRecords) {
      commit('SET_RECORDS_LOADING');
      sendGetRequest(
        url, (data, url) => {
          for (let i in data['results']) {
               data['results'][i].fio= "-"
          }
          commit('SET_RECORDS', data['results']);
          commit('SET_RECORDS_COUNT', data['count']);
          commit('SET_RECORDS_CURRENT_URL', url);
          commit('SET_RECORDS_LOADING_END');
          finalizer(data, url);
        }, (data, url) => {
          commit('SET_RECORDS_LOADING_END');
          commit('SAVE_RECORDS_ERROR', data);
          catcher(data, url);
        }
      )
    }
  },
};

const mutations = {

  SET_RECORDS: (state, obj) => {
    state.records.items = obj
  },
  SET_RECORDS_DETAIL: (state, value) => {
    state.records.detail = value
  },
  SET_RECORDS_COUNT: (state, value) => {
    state.records.count = value
  },
  SET_RECORDS_CURRENT_URL: (state, value) => {
    state.records.currentUrl = value
  },
  SET_RECORDS_LOADING: (state) => {
    state.records.loading = true
  },
  SET_RECORDS_LOADING_END: (state) => {
    state.records.loading = false
  },
  SAVE_RECORDS_ERROR: (state, error) => {
    state.records.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


